VjsAdmin.OneRosterQueue = (function () {
    const me = {};

    me.$table = $('#oneroster-queue-table');
    me.platform_id = me.$table.attr('data-platform-id');
    me.district_joint_guid = me.$table.attr('data-district-joint-guid');

    // quit polling the server if too many errors happen
    me.polling_error = 0;
    me.polling_error_threshold = 2;
    me.polling_timeout = null;

    // amount of time between refreshing the table
    me.polling_interval = 4000;

    me.$queue_sync_modal = null;

    me.init = function () {
        me.initTable();

        SafeDOM.registerQueuePrioritize(me);

        SafeDOM.registerQueueResultsPopup(me);

        SafeDOM.registerQueueSync(me, 'platforms.districts.oneroster.queue.add');
    };

    me.initTable = function () {
        me.$table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#oneroster-queue-table',
            formatNoMatches() {
                return 'No OneRoster History (...yet)';
            },
            idField: 'queue_id',
            sortName: 'date_queued',
            sortOrder: 'DESC',
            search: false,
            url: Slim.Router.pathFor('platforms.districts.oneroster.queue.json', {
                platform_id: me.platform_id,
                district_joint_guid: me.district_joint_guid,
            }),

            ...SafeDOM.makeQueueTableCallbacks(me),
            columns: [
                [
                    {
                        title: 'Status',
                        field: 'status',
                        align: 'center',
                        class: 'status',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'ID',
                        field: 'queue_id',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: '<i class="fa fa-calendar" aria-hidden="true"></i> Queued',
                        field: 'date_queued',
                        align: 'left',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: '<i class="fa fa-calendar" aria-hidden="true"></i> Started',
                        field: 'date_started',
                        align: 'left',
                        valign: 'middle',
                        sortable: false,
                        rowspan: 2,
                    },
                    {
                        title: '<i class="fa fa-calendar" aria-hidden="true"></i> Last Action',
                        field: 'date_last_action',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: '<i class="fa fa-calendar" aria-hidden="true"></i> Finished',
                        field: 'date_finished',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'Size',
                        field: 'file_size',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'Mode',
                        field: 'mode',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'Users',
                        field: 'status',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                        colspan: 6,
                    },
                    {
                        title: 'Classes',
                        field: 'status',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                        colspan: 6,
                    },
                    {
                        title: 'Enrollments',
                        field: 'status',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                        colspan: 4,
                    },
                    {
                        title: 'Errors',
                        field: 'number_of_errors',
                        align: 'center',
                        valign: 'middle',
                        sortable: true,
                        rowspan: 2,
                    },
                    {
                        title: 'Action',
                        field: 'actions',
                        align: 'center',
                        valign: 'middle',
                        sortable: false,
                        rowspan: 2,
                    },
                ],
                [
                    ...SafeDOM.getQueueUsersSubColumns(),
                    ...SafeDOM.getQueueClassesSubColumns(),
                    { title: 'T', field: 'enrollments_total',   align: 'center', valign: 'middle', sortable: false },
                    { title: 'U', field: 'enrollments_updated', align: 'center', valign: 'middle', sortable: false },
                    { title: 'S', field: 'enrollments_skipped', align: 'center', valign: 'middle', sortable: false },
                    { title: 'F', field: 'enrollments_failed',  align: 'center', valign: 'middle', sortable: false },
                ],
            ],
            responseHandler: SafeDOM.makeDistrictQueueResponseHandler({
                rowIdField: 'queue_id',
                hasClassesRow: true,
                /* eslint-disable no-undef */
                formatExtra(row) {
                    row.enrollments_total = number_format(row.enrollments_total);
                    row.enrollments_updated = number_format(row.enrollments_updated);
                    row.enrollments_skipped = number_format(row.enrollments_skipped);
                    row.enrollments_failed = number_format(row.enrollments_failed);
                },
                /* eslint-enable no-undef */
                cancelPermission: 'platforms.districts.oneroster.queue.cancel',
                cancelRoute: 'platforms.districts.oneroster.queue.cancel',
                moveToFrontPermission: 'platforms.districts.oneroster.queue.moveToFront',
                moveToFrontRoute: 'platforms.districts.oneroster.queue.moveToFront',
                moveToFrontParamsBuilder(row) {
                    return { platform_id: row.platform_id, district_joint_guid: row.district_joint_guid, queue_id: row.queue_id };
                },
                logPermission: 'platforms.districts.oneroster.queue.log',
                logRoute: 'platforms.districts.oneroster.queue.log',
            }),
        });
    };

    return {
        init: me.init,
    };
}());
